import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
  useAuditionStatus,
  UseAuditionResubmitMutation,
} from "../../actions/authActions";

export default () => {
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);

  const userId = localStorage.getItem("userId");
  const isLoggedIn = !!userId;

  const { data: auditionStatusData, isLoading: isLoadingAuditionStatus } =
    useAuditionStatus(isLoggedIn);

  const hasSubmission =
    auditionStatusData?.has_submission === true ||
    auditionStatusData?.has_submission === "true";

  const auditionStatusValue = (auditionStatusData?.audition_status || "")
    .toString()
    .toLowerCase();
  const isRejected = auditionStatusValue === "rejected";
  const rejectionReason = auditionStatusData?.rejection_reason;

  useEffect(() => {
    if (
      isLoggedIn &&
      !isLoadingAuditionStatus &&
      auditionStatusData &&
      !hasSubmission
    ) {
      navigate("/gem-audition-form");
    }
  }, [
    isLoggedIn,
    isLoadingAuditionStatus,
    auditionStatusData,
    hasSubmission,
    navigate,
  ]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const video = watch("video");
  const proofOfPayment = watch("proof_of_payment");
  const videoFile = video?.[0];
  const proofOfPaymentFile = proofOfPayment?.[0];

  const [videoPreview, setVideoPreview] = useState(null);
  const [proofOfPaymentPreview, setProofOfPaymentPreview] = useState(null);

  useEffect(() => {
    if (!videoFile) {
      setVideoPreview(null);
      return;
    }
    const url = URL.createObjectURL(videoFile);
    setVideoPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [videoFile]);

  useEffect(() => {
    if (!proofOfPaymentFile) {
      setProofOfPaymentPreview(null);
      return;
    }
    const url = URL.createObjectURL(proofOfPaymentFile);
    setProofOfPaymentPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [proofOfPaymentFile]);

  const resubmitMutation = UseAuditionResubmitMutation(setLoadingToapi);

  const onSubmit = (data, e) => {
    e.preventDefault();

    Swal.fire({
      title: "Resubmit your GEM Audition?",
      text: "Please confirm you want to resubmit your updated audition details.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d9a239",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Resubmit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      setLoadingToapi(true);
      const payload = new FormData();
      payload.append("video", data.video?.[0]);
      payload.append("proof_of_payment", data.proof_of_payment?.[0]);
      resubmitMutation.mutate(payload);
    });
  };

  return {
    navigate,
    isLoggedIn,
    isLoadingAuditionStatus,
    hasSubmission,
    auditionStatusValue,
    isRejected,
    rejectionReason,
    register,
    handleSubmit,
    errors,
    onSubmit,
    loadingToapi,
    video,
    proofOfPayment,
    videoPreview,
    proofOfPaymentPreview,
  };
};
